import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import Input from './Input'
import SearchIcon from './icons/search'
import FiltersIcon from './icons/filters'
import Button from './Button'

const initialState = {
    query: '',
    role: '',
}

const ClientFilters = ({
    onFilterChange,
}) => {

    const { t } = useTranslation()
    const [filters, setFilters] = useState(initialState)
    const [filtersOpened, setFiltersOpened] = useState(false)

    useEffect(() => {
        if (onFilterChange) onFilterChange(filters)
    }, [])

    const setField = (field, value) => {
        const newVal = {
            ...filters,
            [field]: value,
        }

        setFilters(newVal)

        if (onFilterChange) onFilterChange(newVal)
    }

    return (
        <div
            className={`filters-wrapper${filtersOpened ? ' filters--open' : ''}`}
        >
            <Button
                className='btn-filters'
                icon={<FiltersIcon fill={'#fff'} />}
                label={filtersOpened ? t('filters.filter_close') : t('filters.filter')}
                onClick={() => setFiltersOpened(!filtersOpened)}
            />
            <div className='filters filters-user'>
                <div className='filters-search--query'>
                    <Input
                        label={ t('clients.search_title') }
                        placeholder={ t('clients.search') }
                        onChange={(e) => setField('query', e.target.value)}
                        value={filters.query}
                        icon={<SearchIcon />}
                    />
                </div>
            </div>
        </div>
    )
}

ClientFilters.propTypes = {
    onFilterChange: PropTypes.func,
}

export default ClientFilters